"use client";
import { useMemo } from "react";
import { ICMS } from "@/store/home/homeModel";
import { cleanHeaderTags, createLookupObject, decodeHtml } from "@/lib/helper";
import Banner from "@/components/Banner";
import { OptimizedImage } from "@/components/common/OptimizedImage";

interface AboutUsProps {
  cmsData: ICMS[];
  bannerData: any[]; // Or define strict IBanner interface
}

export function Aboutus({ cmsData, bannerData }: AboutUsProps) {
  const lookUpCMSData = useMemo(() => {
    return createLookupObject(cmsData || [], "Name");
  }, [cmsData]);

  const banner =
    bannerData?.filter((banner: any) => banner?.BannerType === "about-us") ||
    [];

  return (
    <>
      <Banner BannerList={banner} />

      {/* Our Story Section */}
      {lookUpCMSData?.["About  - Section 2 Our Story"] && (
        <section className="py-20 bg-gradient-to-b from-white to-[#F3EBDD]/30">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div
                dangerouslySetInnerHTML={{
                  __html: cleanHeaderTags(
                    decodeHtml(
                      lookUpCMSData?.["About  - Section 2 Our Story"]?.Template,
                    ),
                  ),
                }}
              />
              <div className="grid grid-cols-2 gap-6">
                <div className="relative h-80 rounded-3xl overflow-hidden shadow-2xl">
                  <OptimizedImage
                    src={
                      lookUpCMSData?.["About  - Section 2 Our Story"]?.CMSImage
                    }
                    alt={
                      lookUpCMSData?.["About  - Section 2 Our Story"]
                        ?.CMSImageAlterTag || "Forest view"
                    }
                    width={800}
                    height={600}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="relative h-80 rounded-3xl overflow-hidden shadow-2xl mt-12">
                  <OptimizedImage
                    src={
                      lookUpCMSData?.["About  - Section 2 Our Story img 2"]
                        ?.CMSImage
                    }
                    alt={
                      lookUpCMSData?.["About  - Section 2 Our Story img 2"]
                        ?.CMSImageAlterTag || "Nature"
                    }
                    width={800}
                    height={600}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {lookUpCMSData?.["About  - Section 3: Why Choose"] && (
        <div
          dangerouslySetInnerHTML={{
            __html: cleanHeaderTags(
              decodeHtml(
                lookUpCMSData?.["About  - Section 3: Why Choose"]?.Template,
              ),
            ),
          }}
        />
      )}

      {/* Visual Story Blocks */}
      <section className="py-20 bg-gradient-to-b from-white to-[#F3EBDD]/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 space-y-16">
          {lookUpCMSData?.["About  - Section 4: Wildlife Paradise"] && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="h-96 rounded-3xl overflow-hidden shadow-2xl">
                <OptimizedImage
                  src={
                    lookUpCMSData?.["About  - Section 4: Wildlife Paradise"]
                      ?.CMSImage
                  }
                  alt={
                    lookUpCMSData?.["About  - Section 4: Wildlife Paradise"]
                      ?.CMSImageAlterTag || "Wildlife"
                  }
                  width={800}
                  height={600}
                  className="w-full h-full object-cover"
                />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: cleanHeaderTags(
                    decodeHtml(
                      lookUpCMSData?.["About  - Section 4: Wildlife Paradise"]
                        ?.Template,
                    ),
                  ),
                }}
              />
            </div>
          )}

          {lookUpCMSData?.["About  - Section 5: Sustainable Living"] && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div
                dangerouslySetInnerHTML={{
                  __html: cleanHeaderTags(
                    decodeHtml(
                      lookUpCMSData?.["About  - Section 5: Sustainable Living"]
                        ?.Template,
                    ),
                  ),
                }}
              />
              <div className="h-96 rounded-3xl overflow-hidden shadow-2xl order-1 lg:order-2">
                <OptimizedImage
                  src={
                    lookUpCMSData?.["About  - Section 5: Sustainable Living"]
                      ?.CMSImage
                  }
                  alt={
                    lookUpCMSData?.["About  - Section 5: Sustainable Living"]
                      ?.CMSImageAlterTag || "Sustainable practices"
                  }
                  width={800}
                  height={600}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          )}
        </div>
      </section>

      {lookUpCMSData?.["About - Section 6: CTA"] && (
        <div
          dangerouslySetInnerHTML={{
            __html: cleanHeaderTags(
              decodeHtml(lookUpCMSData?.["About - Section 6: CTA"]?.Template),
            ),
          }}
        />
      )}
    </>
  );
}
